import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '../../admin/Constant'

export const BlogApi = createApi({
    reducerPath: 'BlogApi',
    baseQuery: fetchBaseQuery({baseUrl: `${API_URL}/blogs`}),
    endpoints: (builder) => ({
        addBlog: builder.mutation({
            query: (data) => ({
             url: `create`,
             method: "POST",
             body: data
            })
         }),
        allBlog: builder.query({
            query: () => ({
             url: "all",
             method: "GET",
            })
         }),
        getBlogDetails: builder.query({
            query: (slug) => ({
                url: `detail/${slug}`,
                method: "GET",
            })
         }),
        deleteBlog: builder.mutation({
            query: (id) => ({
             url: `delete/${id}`,
             method: "DELETE",
            })
         }),
         updateBlog: builder.mutation({
            query: (data) => ({
             url: `update`,
             method: "PUT",
             body: data
            })
         }),
         updateBlogStatus: builder.mutation({
            query: (id) => ({
              url: `status/${id}`,
              method: "PATCH",
            }),
          }),
         }),
})
export const { useAddBlogMutation, useAllBlogQuery, useDeleteBlogMutation, useGetBlogDetailsQuery, useUpdateBlogMutation,  useUpdateBlogStatusMutation,
} = BlogApi
